import { Registration } from "@p0security/shared/integrations/types";

import { DatadogComponents } from "./components.ts";

export const DatadogIconUrl =
  "https://imgix.datadoghq.com/img/dd_logo_70x75.png";

export const DatadogRegistration = Registration({
  category: "other",
  components: DatadogComponents,
  docs: {},
  itemKind: "endpoint",
  label: "Datadog",
  logoUrl: DatadogIconUrl,
  maturity: "beta",
});
